/**
 * A ORDEM DOS DOCUMENTOS NO ARQUIVO ÚNICO (dossiê) da publicação para o órgão (15/10/2026, PR-2 do plano do Heitor).
 *
 * ⛔ Com `config.dossierDocumentIds` preenchido, o backend monta o dossiê SÓ com os ids da lista
 * (`procurement-publication.service.ts`, montarDossie: map + filter). Um documento marcado depois e fora da lista
 * sumiria do arquivo único sem aviso. Por isso a ordem que vai ao servidor é SEMPRE a lista inteira dos marcados:
 * primeiro os que a pessoa já ordenou (na ordem dela), depois os marcados que ainda não estavam lá, na ordem da árvore.
 *
 * Só documentos de UPLOAD (habilitação). Os gerados (proposta, declarações) vão na página e não entram no arquivo único:
 * o backend só lê `documentos` no montarDossie.
 */

/** A ordem a mostrar e a gravar: a escolhida, sem os desmarcados, mais os marcados novos na ordem da árvore. */
export function ordemDoDossie(escolhida: number[] | null | undefined, marcadosNaOrdemDaArvore: number[]): number[] {
  const marcados = new Set(marcadosNaOrdemDaArvore);
  const vistos = new Set<number>();
  const out: number[] = [];
  for (const id of escolhida || []) {
    if (marcados.has(id) && !vistos.has(id)) { out.push(id); vistos.add(id); }
  }
  for (const id of marcadosNaOrdemDaArvore) {
    if (!vistos.has(id)) { out.push(id); vistos.add(id); }
  }
  return out;
}

/** Move o elemento da posição `de` para a posição `para` (arrastar, ou ↑/↓). Fora dos limites, devolve igual. */
export function mover<T>(lista: T[], de: number, para: number): T[] {
  if (de === para || de < 0 || para < 0 || de >= lista.length || para >= lista.length) return lista;
  const out = [...lista];
  const [x] = out.splice(de, 1);
  out.splice(para, 0, x);
  return out;
}
